import React from 'react';
import Home from '../Home';
import DashboardImg from '../../img/dashboard.webp'

// Reusable SVG Icon Components
const CheckCircleIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-6 h-6 text-green-500"
  >
    <path
      fillRule="evenodd"
      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.882l-3.484 4.195-1.958-1.594a.75.75 0 0 0-1.223.806l2.508 2.507a.75.75 0 0 0 1.135-.075l4.04-4.524Z"
      clipRule="evenodd"
    />
  </svg>
);

const CalendarIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h3.75m-9-3.75h9m-9 7.5h6"
    />
  </svg>
);

const ChartBarIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 13.125m0 2.25c0 1.5.75 2.25 2.25 2.25H21m-18-4.5V3.75m0 9.375a.75.75 0 0 1 0 1.5H21a.75.75 0 0 1 0-1.5m-18 0V3.75A2.25 2.25 0 0 1 5.25 1.5h13.5A2.25 2.25 0 0 1 21 3.75v9.375m0-9.375h.375a.375.375 0 0 1 .375.375v.5A.375.375 0 0 1 21.375 5.5h-.375M3.75 4.5h.375A.375.375 0 0 1 4.5 4.875v.5A.375.375 0 0 1 4.125 5.75H3.75m16.5 2.25h.375a.375.375 0 0 1 .375.375v.5A.375.375 0 0 1 20.625 9.5h-.375m-16.5-1.5h.375A.375.375 0 0 1 4.5 8.375v.5A.375.375 0 0 1 4.125 9.25H3.75m16.5 2.25h.375a.375.375 0 0 1 .375.375v.5a.375.375 0 0 1-.375.375h-.375m-16.5-1.5h.375a.375.375 0 0 1 .375.375v.5A.375.375 0 0 1 4.125 11.75H3.75M12 21v-7.5m-.75-.75h1.5m-3.75 0h7.5"
    />
  </svg>
);

const BellIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.57 3.511.96 5.302 1.096A48.394 48.394 0 0 1 12 15c1.801 0 3.568.377 5.367 1.055a.75.75 0 0 0 .14.775Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.868 18.84a3.75 3.75 0 1 0 7.264 0"
    />
  </svg>
);

const WalletIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15m-5.83 4.29-2.924-2.925m3.153 3.15-2.73-2.73m6.11-1.396-1.332-1.332M13.5 12h5.25M13.5 12a2.25 2.25 0 0 0 2.25-2.25m-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25m-3.75 2.25c.343.435.655.882.946 1.332-.23.136-.452.28-.667.433-.93.666-1.745 1.5-2.454 2.454C4.853 18.36 3.75 20.378 3.75 22.5h16.5c0-2.122-1.103-4.14-2.825-5.912C16.89 15.658 15.358 14.28 13.5 13.5"
    />
  </svg>
);


function OnlineAppointmentSystem() {
  return (
    <Home>
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800 antialiased">
      {/* Tailwind CSS is assumed to be available. */}
      <script src="https://cdn.tailwindcss.com"></script>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" />
      <style>{`body { font-family: 'Inter', sans-serif; }`}</style>

      {/* Hero Section */}
      <header className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16 px-4 sm:px-6 lg:px-8 shadow-xl">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-4">
            The Future of Clinic Management is Here
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl font-light mb-8 max-w-2xl mx-auto">
            Our online appointment system streamlines your practice, saves you time, and delights your patients.
          </p>
          <button className="bg-white text-blue-600 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
            Get Started Today
          </button>
        </div>
      </header>

      {/* Benefits Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Why Doctors and Clinics Love Our System</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-blue-500 rounded-full flex items-center justify-center mb-6">
                <CalendarIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">24/7 Booking</h3>
              <p className="text-gray-600">
                Patients can book appointments anytime, anywhere, reducing phone calls and administrative burden.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mb-6">
                <BellIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Automated Reminders</h3>
              <p className="text-gray-600">
                Decrease no-shows with automated email and SMS reminders, keeping your schedule full and efficient.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-purple-500 rounded-full flex items-center justify-center mb-6">
                <ChartBarIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Actionable Insights</h3>
              <p className="text-gray-600">
                Gain valuable insights into patient trends, popular services, and peak booking times with powerful analytics.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <WalletIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Secure Payments</h3>
              <p className="text-gray-600">
                Process co-pays and deposits securely online, improving cash flow and reducing front desk friction.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* System Screenshot Section */}
      <section className="bg-gray-100 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">A System Built for You</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Experience our clean, intuitive dashboard designed to make managing your clinic effortless.
          </p>
          <div className="rounded-2xl shadow-xl overflow-hidden border border-gray-200">
            <img
              src={DashboardImg}
              alt="System Dashboard Screenshot"
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="bg-gray-100 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Our Beautiful Features</h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-white p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Intuitive Patient Portal</h3>
                <p className="text-gray-600">
                  A beautifully designed, mobile-first portal where patients can effortlessly book, reschedule, and cancel appointments with just a few taps.
                </p>
              </div>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Intelligent Scheduling Engine</h3>
                <p className="text-gray-600">
                  Our smart algorithm automatically suggests the best appointment slots based on your staff availability, room allocation, and service type.
                </p>
              </div>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Automated Waitlist Management</h3>
                <p className="text-gray-600">
                  When a cancellation occurs, our system automatically notifies patients on your waitlist, ensuring your schedule stays full and productive.
                </p>
              </div>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Comprehensive Telehealth Integration</h3>
                <p className="text-gray-600">
                  Seamlessly connect with patients through integrated video conferencing, making virtual consultations easy and secure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">What Our Clients Say</h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            Hear from doctors and clinic managers who have transformed their practices with our platform.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "Our no-show rate has dropped by over 50% since we implemented this system. It's a game-changer for our clinic's efficiency."
              </p>
              <p className="font-semibold text-blue-600">- Dr. Jane Doe</p>
              <p className="text-sm text-gray-500">Family Medicine Clinic</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "The patient portal is so easy to use. Our patients love the ability to book appointments 24/7 without needing to call us."
              </p>
              <p className="font-semibold text-blue-600">- Robert Williams</p>
              <p className="text-sm text-gray-500">Clinic Manager, City Health</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "The analytics dashboard gives us a clear picture of our patient flow. It has helped us optimize our staffing and hours."
              </p>
              <p className="font-semibold text-blue-600">- Dr. Michael Chen</p>
              <p className="text-sm text-gray-500">Advanced Pediatrics Group</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Simple, Transparent Pricing</h2>
          <p className="text-lg text-gray-600 mb-12">
            Choose the plan that fits your practice, with no hidden fees and the flexibility to upgrade anytime.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Basic Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="flex-grow">
                <h3 className="text-2xl font-bold mb-2">Starter</h3>
                <p className="text-gray-600 mb-4">Perfect for new and single-doctor clinics.</p>
                <p className="text-4xl font-extrabold mb-6">₹7000<span className="text-xl font-medium text-gray-500">/mo</span></p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Unlimited Appointments</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />1 Doctor Profile</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Patient Portal Access</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Email Notifications</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Basic Reporting</li>
                </ul>
              </div>
              <button className="w-full bg-blue-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-blue-700 transition-colors">
                Select Starter
              </button>
            </div>
            {/* Pro Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border-2 border-blue-600 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl relative">
              <span className="absolute top-0 right-0 -mt-3 -mr-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">Most Popular</span>
              <div className="flex-grow">
                <h3 className="text-2xl font-bold mb-2">Professional</h3>
                <p className="text-gray-600 mb-4">Ideal for growing multi-doctor practices.</p>
                <p className="text-4xl font-extrabold mb-6">9999<span className="text-xl font-medium text-gray-500">/mo</span></p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Everything in Starter</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Up to 5 Doctor Profiles</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />SMS & Email Reminders</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Secure Online Payments</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Advanced Analytics</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Customizable Forms</li>
                </ul>
              </div>
              <button className="w-full bg-blue-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-blue-700 transition-colors">
                Select Professional
              </button>
            </div>
            {/* Enterprise Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="flex-grow">
                <h3 className="text-2xl font-bold mb-2">Enterprise</h3>
                <p className="text-gray-600 mb-4">For large clinics and hospital systems.</p>
                <p className="text-4xl font-extrabold mb-6">Contact Us</p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Everything in Professional</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Unlimited Doctor Profiles</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Dedicated Support Manager</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Telehealth Integration</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />HIPAA/GDPR Compliance</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Custom API Access</li>
                </ul>
              </div>
              <button className="w-full bg-blue-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-blue-700 transition-colors">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Frequently Asked Questions</h2>
          <div className="space-y-6">
            {/* FAQ Item 1 */}
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Is the system secure?</h3>
              <p className="text-gray-600">
                Yes, our system uses industry-standard encryption protocols to protect all patient data. We are fully compliant with HIPAA and GDPR regulations to ensure the highest level of security and privacy.
              </p>
            </div>
            {/* FAQ Item 2 */}
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">How long does it take to set up?</h3>
              <p className="text-gray-600">
                For most clinics, setup is quick and can be completed in as little as 30 minutes. Our onboarding team provides a step-by-step guide and dedicated support to get you up and running smoothly.
              </p>
            </div>
            {/* FAQ Item 3 */}
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">What kind of support is offered?</h3>
              <p className="text-gray-600">
                We offer 24/7 customer support via email and live chat for all our plans. Our Professional and Enterprise plans also include dedicated phone support and a dedicated account manager.
              </p>
            </div>
            {/* FAQ Item 4 */}
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Can I customize the patient portal?</h3>
              <p className="text-gray-600">
                Yes, our system allows for extensive customization of the patient portal, including your clinic's logo, colors, and a personalized welcome message to create a seamless brand experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-blue-600 text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to Transform Your Clinic?</h2>
          <p className="text-lg sm:text-xl font-light mb-8">
            Join thousands of clinics who have streamlined their operations and boosted patient satisfaction with our powerful appointment system.
          </p>
          <button className="bg-white text-blue-600 font-semibold px-10 py-4 rounded-full shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
            Start Your Free Trial
          </button>
        </div>
      </section>

   
    </div>
    </Home>
  );
}

export default OnlineAppointmentSystem;



